module.exports = __webpack_public_path__ + "9ec48d55abf035cf7caf5e0899625cb8.png";